import type { MouseEventHandler } from 'react';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { Settings } from '@atlaskit/navigation-system/top-nav-items';

import { START_TOUCH } from '@confluence/navdex/entry-points/NavdexPointType';
import {
	useRouteDataRef,
	useRouteActions,
} from '@confluence/route-manager/entry-points/RouteState';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery';
import { ADMIN_SETTINGS } from '@confluence/named-routes/entry-points/routes';
import { fg } from '@confluence/feature-gating';

import { PostOfficeHtmlTarget } from './PostOfficeHtmlTarget';

export const SettingsButton = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const routeData = useRouteDataRef();
	const { push } = useRouteActions();

	const onClick: MouseEventHandler = (e) => {
		const url = ADMIN_SETTINGS.toUrl();

		if (e.metaKey) {
			window.open(url, '_blank', 'noreferrer');
		} else {
			push(url);
		}

		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				source: 'globalNavigation',
				action: 'clicked',
				actionSubject: 'navigationItem',
				actionSubjectId: 'settings',
				attributes: {
					selectedItemPageContext: routeData.current?.routeName,
					navigationLayer: 'global',
					navVersion: '4',
					navdexPointType: START_TOUCH,
				},
			},
		}).fire();
	};

	const { accessStatus } = useSessionData();
	const isAdmin = accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS;

	return isAdmin ? (
		fg('post-office_ep_migration_inapp_715_nav4') ? (
			<PostOfficeHtmlTarget id="ep-migration-inapp-715-target">
				<Settings onClick={onClick} label={<FormattedMessage {...i18n.settings} />} />
			</PostOfficeHtmlTarget>
		) : (
			<Settings onClick={onClick} label={<FormattedMessage {...i18n.settings} />} />
		)
	) : null;
};

const i18n = defineMessages({
	settings: {
		id: 'app-navigation.top-navigation.settings',
		defaultMessage: 'Confluence administration',
		description: 'Label for the top navigation global admin settings button',
	},
});
